import HttpClient from "@/common/boot/HttpClient"

const recuperarTarefa = ({ commit }, payload) => {
  return HttpClient.get(`/ctrl-tarefas/${payload.id}`).then(response => {
      commit('INSERIR_TAREFA_SELECIONADA', response.data.data)
      return response.data.data
  });
}

const listarFilasDeTarefas = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  
  return HttpClient.get('/ctrl-tarefas/filas', { params: payload }).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const listarWorkflowsPorTarefa = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  
  const { centro_funcional, ...resto } = payload || {}
  const params = {
    ...resto,
    ...(centro_funcional ? { centro_funcional } : {}),
  }

  return HttpClient.get(`/ctrl-tarefas/filas/${payload.ctrl_tarefa_id}`, { params }).then(response => {
      commit('LISTAR_DADOS_WORKFLOWS', response.data.data);
      return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const dadosFilasTarefa = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  payload.sem_aguardando_paralilesmo = true;
  return HttpClient.post(`/gestao-producao/filas-tarefa/dados/${payload.ctrl_tarefa_id[0]}`, payload).then(response => {
      commit('LISTAR_DADOS_TAREFA', response.data.data);
      return response;
  }).finally(() => {
    commit('CARREGANDO', false);
  });
}

const totaisFilasTarefa = async ({ commit }, payload) => {
  return HttpClient.post(`/gestao-producao/filas-tarefa/totais/${payload.ctrl_tarefa_id[0]}`, payload).then(response => {
      commit('LISTAR_TOTAIS_TAREFA', response.data);
      return response;
  });
}

export {
  recuperarTarefa,
  listarFilasDeTarefas,
  listarWorkflowsPorTarefa,
  dadosFilasTarefa,
  totaisFilasTarefa
}